<template>
  <div class="solidmesh-property-form-table">
    <v-table :class="['simple-table', transparent ? 'transparent-table-bg' : '']" hover density="compact">
      <tbody>
        <slot />
      </tbody>
    </v-table>
  </div>
</template>

<script>
export default {
	name: "SolidMeshPropertyFormTable",
	props: {
		transparent: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
/* Scoped via wrapper class to avoid global leakage */
.solidmesh-property-form-table :deep(.transparent-table-bg) {
  background-color: rgba(41, 41, 47, 0);
}

.solidmesh-property-form-table :deep(.v-text-field--underlined) {
  opacity: 0.9;
}

.solidmesh-property-form-table :deep(.simple-table) {
  width: 100%;
  table-layout: fixed;
}

.solidmesh-property-form-table :deep(.simple-table td:first-child) {
  width: 40%;
  padding-right: 8px;
  vertical-align: middle;
}

.solidmesh-property-form-table :deep(.simple-table td:nth-child(2)) {
  width: 60%;
}

.solidmesh-property-form-table :deep(.simple-table td:last-child) {
  padding-left: 0;
}

.solidmesh-property-form-table :deep(.simple-table .v-field) {
  width: 100%;
  max-width: 320px;
  box-sizing: border-box;
}

.solidmesh-property-form-table :deep(.simple-table td.coordinate-label) {
  width: 14% !important;
  padding-right: 8px;
  white-space: nowrap;
}

.solidmesh-property-form-table :deep(.inline-fields) {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.solidmesh-property-form-table :deep(.small-input) {
  max-width: 120px;
  flex: none;
}

.solidmesh-property-form-table :deep(.small-select) {
  max-width: 160px;
  flex: none;
}

.solidmesh-property-form-table :deep(.simple-table td.row-title.highlight-title) {
  background-color: rgba(255, 255, 255, 0.04) !important;
}

.solidmesh-property-form-table :deep(.simple-table tr:hover > td.row-title) {
  background-color: transparent !important;
}

.solidmesh-property-form-table :deep(.simple-table td) {
  transition: background-color 0s !important;
}

.solidmesh-property-form-table :deep(.simple-table tr.manhole-custom-row--hidden) {
  height: 0;
  overflow: hidden;
}

.solidmesh-property-form-table :deep(.simple-table tr.manhole-custom-row--hidden td) {
  padding: 0;
  height: 0;
  border: none;
  overflow: hidden;
}

.solidmesh-property-form-table :deep(.simple-table tr.manhole-custom-row--hidden .v-field) {
  display: none;
}
</style>
